import { render } from "./request_admission_modal.vue?vue&type=template&id=532721e2&scoped=true"
import script from "./request_admission_modal.vue?vue&type=script&lang=js"
export * from "./request_admission_modal.vue?vue&type=script&lang=js"

import "./request_admission_modal.vue?vue&type=style&index=0&id=532721e2&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532721e2"]])

export default __exports__